import { useMemo } from 'react';
import {
  TimeSignalAttribute,
  useTimeSignalAttributesQuery
} from 'graphql/types';

export const useTimeSignalAttributes: (
  id: string
) => {
  loading: boolean;
  attributes?: TimeSignalAttribute[];
} = (id) => {
  const { loading, data } = useTimeSignalAttributesQuery({
    variables: {
      id: id
    },
    fetchPolicy: 'cache-first'
  });

  return useMemo(
    () => ({
      loading,
      attributes: data?.timeSignal?.attributes as TimeSignalAttribute[]
    }),
    [data, loading]
  );
};
